export default __webpack_public_path__ + "static/media/Hardware Free - Header.20f93ee6.png";